'use strict';

const $ = window.jQuery;

export default function() {
    openHoleFunc, closeHoleFunc,

        openHoleFunc();

    var title = document.querySelector( '.join-us__main .join-us__title' );

    if ( ! title ) {
        return;
    }
    var span = title.querySelector( 'span' );
    var scroll = $( window ).scrollTop();
    if ( scroll < 200 ) {
        title.style.transform = 'translateX(-' + scroll / 4 + 'px)';
        span.style.transform = 'translateX(+' + scroll / 2 + 'px)';
    }
    $( window ).scroll( function() {
        title = document.querySelector( '.join-us__main .join-us__title' );
        span = title.querySelector( 'span' );
        scroll = $( window ).scrollTop();
        if ( scroll < 200 ) {
            title.style.transform = 'translateX(-' + scroll / 4 + 'px)';
            span.style.transform = 'translateX(+' + scroll / 2 + 'px)';
        }

        openHoleFunc();
        closeHoleFunc();
    } );

};

function closeHoleFunc() {
    let scroll = $( window ).scrollTop();
    let closeHole = document.querySelector( '.join-us-ending-hole__header-image' );
    let rect = closeHole.getBoundingClientRect();
    //console.log(rect.top );
    if ( rect.top < 0 ) {
        let percentage = 100 - ( ( -rect.top ) * 100 / closeHole.clientHeight ) + 5;
        if ( percentage > 0 ) {
            //closeHole.setAttribute("style", 'clip-path: circle(' + percentage + '% at 50% 0%);');
        }
        console.log( percentage );
    }
}

function openHoleFunc() {
    let scroll = $( window ).scrollTop();
    let openHole = document.querySelector( '.join-us-open-hole__header-image' );
    let arrow = document.querySelector( '.i-arrow-down-pme' );
    if ( ! arrow ) {
        return;
    }
    let header = document.querySelector( '#header' );
    let percentage = scroll * 100 / window.innerHeight;
    if ( percentage < 8.4562 ) {
        percentage = 8.4562;
    }
    if ( percentage > 30 ) {
        arrow.classList.add( 'desactivate' );
    } else {
        arrow.classList.remove( 'desactivate' );
    }
    if ( percentage > 100 ) {
        percentage = 100;

        openHole.setAttribute( 'style', 'clip-path: circle(' + percentage + '% at 50% 100%); top: -' + Math.floor( scroll - window.innerHeight - header.clientHeight ) + 'px;' );
    } else {
        openHole.setAttribute( 'style', 'clip-path: circle(' + percentage + '% at 50% 100%);' );
    }
}
